import { Leads, LeadSource } from "../../../models/Leads/leads";
import { LeadsFilters } from "../../../models/Leads/leadsFilter";
import {
  NewAPIResponse,
  PaginatedAPIResponse,
} from "../../../models/NetworkResponse";
import { getAPI } from "../../../api/Networking";

export default class LeadAPI {
  getLeads = async (
    filters: LeadsFilters,
  ): Promise<PaginatedAPIResponse<Leads>> => {
    try {
      const queryParams = new URLSearchParams();

      if (filters.page_no)
        queryParams.append("page_no", filters.page_no.toString());

      if (filters.limit) queryParams.append("limit", filters.limit.toString());

      if (filters.search_text)
        queryParams.append("search_text", filters.search_text.toString());

      if (filters.sort_by)
        queryParams.append("sort_by", filters.sort_by.toString());

      if (filters.sort_type)
        queryParams.append("sort_type", filters.sort_type.toString());

      if (filters.sources)
        queryParams.append(
          "sources",
          filters.sources.map((source) => source.id).join(","),
        );

      const response = await getAPI(`/v5/leads?${queryParams.toString()}`);
      return response.result;
    } catch (error) {
      throw error;
    }
  };

  getSources = async (): Promise<NewAPIResponse<LeadSource[]>> => {
    try {
      const response = await getAPI(`/v5/leads/sources`);
      return response as NewAPIResponse<LeadSource[]>;
    } catch (error) {
      throw error;
    }
  };
}
